import React from 'react';
import { Wrapper } from '@googlemaps/react-wrapper';
import { GOOGLE_MAPS_API_KEY, GOOGLE_MAPS_LIBRARIES, GOOGLE_MAPS_VERSION } from 'config/googleMaps.config';

type GoogleMapWrapperProps = {
  children: React.ReactNode;
};

const GoogleMapWrapper: React.FC<GoogleMapWrapperProps> = ({ children }) => {
  return (
    <Wrapper apiKey={GOOGLE_MAPS_API_KEY} version={GOOGLE_MAPS_VERSION} libraries={GOOGLE_MAPS_LIBRARIES}>
      {children}
    </Wrapper>
  );
};

export default GoogleMapWrapper;
